<template>
  <div style="padding-bottom: 50px">
    <el-card style="margin-bottom: 0.25rem">
      <el-row class="flex-between">
        <el-col>
          <el-date-picker
            @change="onChangeTime"
            v-model="indexInfo.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>

          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="onEditFood"
            v-if="timeDasibale"
            >新增本周菜肴
          </el-button>
          <el-button type="goon" style="margin-left: 20px" @click="onRecommend"
            >选择推荐食谱</el-button
          >
          <el-button
            v-if="TableStr != ''"
            type="goon"
            style="margin-left: 20px"
            @click="onClickExport"
            >导出</el-button
          >
        </el-col>
        <el-col class="flex" style="justify-content: flex-end">
          <el-button
            type="goon"
            style="margin-left: 20px"
            v-show="isShowBtn"
            @click="onClickOpenBtn"
            >完成修改</el-button
          >
          <el-button
            type="goon"
            v-show="!isShowBtn"
            style="margin-left: 20px"
            @click="onClickOpen"
            >修改食谱</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <div v-html="TableStr" class="tui-Content" v-show="!isOpen"></div>
    <el-card v-if="TableStr == ''">
      <el-empty description="暂无食谱"></el-empty>
    </el-card>
    <el-card v-show="isOpen" style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :span-method="objectSpanMethod"
        :cell-class-name="tableRowClassName"
        @cell-mouse-leave="cellMouseLeave"
        @cell-mouse-enter="cellMouseEnter"
        border
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
      >
        <el-table-column prop="WeekDay" label="时间段" align="center">
          <template slot-scope="scope">
            <el-dropdown
              @command="onClickDeleteDrop($event, scope.row)"
              v-if="timeDasibale"
            >
              <div style="font-weight: 600; color: #333">
                {{ scope.row.WeekDay }}
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
              {{ scope.row.WeekDay }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="GradeName"
          label="年龄段"
          align="center"
        ></el-table-column>
        <el-table-column label="早点" align="center">
          <template slot-scope="scope">
            <div v-for="(qq, ww) in scope.row.AbitEarlier" :key="ww">
              <el-dropdown
                v-if="timeDasibale"
                @command="
                  onClickDropdown($event, qq, scope.row, '早点', '早点')
                "
              >
                <div style="font-weight: 600; color: #333">
                  {{ qq.DishName }}
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit">编辑</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                {{ qq.DishName }}
              </div>
              {{ qq.weight == 0 ? "" : qq.weight + "g" }}
              <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                {{ cc }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午餐-主食" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_StapleFood" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '主食')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
                <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                  {{ cc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午餐-菜肴" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_Dish" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '菜肴')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
                <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                  {{ cc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午餐-汤" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_Soup" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '汤')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
                <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                  {{ cc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="营养加点-体弱儿" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_Nutrition" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '水果')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="营养加点-病号菜" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_Nutrition_Sick" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '水果')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午餐-水果" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Lunch_Fruits" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午餐', '水果')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
                <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                  {{ cc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午点" align="center">
          <template slot-scope="scope">
            <div class="flex-arounds">
              <div v-for="(qq, ww) in scope.row.Noon" :key="ww">
                <el-dropdown
                  v-if="timeDasibale"
                  @command="
                    onClickDropdown($event, qq, scope.row, '午点', '午点')
                  "
                >
                  <div style="font-weight: 600; color: #333">
                    {{ qq.DishName }}
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div style="font-weight: 600; color: #333" v-if="!timeDasibale">
                  {{ qq.DishName }}
                </div>
                {{ qq.weight == 0 ? "" : qq.weight + "g" }}
                <div v-for="(cc, bb) in qq.DetailInfo" :key="bb">
                  {{ cc }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :title="foodTitle" :visible.sync="dialogVisible" width="70%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
          label-width="100px"
        >
          <el-form-item label="年龄段：" prop="gradeIdentity">
            <el-select
              v-model="ruleForm.gradeIdentity"
              placeholder="请选择年龄段"
            >
              <el-option
                v-for="item in agsList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="weekDay">
            <el-select v-model="ruleForm.weekDay" placeholder="请选择时间">
              <el-option
                v-for="item in dateOptions"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用餐时段：" prop="type">
            <el-select v-model="ruleForm.type" placeholder="用餐时段">
              <el-option
                v-for="item in foodLunch"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜肴特性：" prop="apply">
            <el-select v-model="ruleForm.apply" placeholder="菜肴特性">
              <el-option
                v-for="item in foodCharacter"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜肴：" prop="foodDish">
            <el-select
              v-model="ruleForm.foodDish"
              placeholder="请选择"
              @change="onChangeFoodDish"
            >
              <el-option
                v-for="item in foodDishList"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="菜肴名称："
            v-if="ruleForm.foodDish == '菜肴'"
            prop="foodDishName"
          >
            <div style="font-size: 12px">
              *必须选择查询到的菜肴，如果查询为空时自主输入的菜肴无法提交或编辑
            </div>
            <el-autocomplete
              v-model="ruleForm.foodDishName"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入菜肴关键字"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item
            label="菜肴名称："
            v-if="ruleForm.foodDish != '菜肴'"
            prop="foodLibaryName"
          >
            <div style="font-size: 12px">
              *必须选择查询到的食物，如果查询为空时自主输入的食材/食物无法提交或编辑
            </div>
            <el-autocomplete
              v-model="ruleForm.foodLibaryName"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入食物/食材关键字"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>

          <el-form-item
            label="克数"
            prop="weight"
            v-if="ruleForm.foodDish != '菜肴'"
          >
            <el-input
              v-model="ruleForm.weight"
              style="width: auto"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="主食："
            v-if="ruleForm.type == '午餐' && ruleForm.apply == '正常'"
            prop="secType"
          >
            <el-select v-model="ruleForm.secType" placeholder="主食">
              <el-option
                v-for="item in secTypeList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="goon" @click="addSubmit('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 选择推荐食谱 -->
    <el-dialog
      title="选择推荐食谱"
      :visible.sync="dialogVisibleRecommend"
      width="80%"
    >
      <div class="List">
        <div
          :class="['grade', weekIndex == index ? 'gradeActive' : '']"
          :style="{
            'z-index': weekList.length + 3 - index,
            transform: 'translateX(' + index * 34 * -1 + 'px)',
          }"
          v-for="(item, index) in weekList"
          :key="index"
          @click="onClickWeek(index, item)"
        >
          {{ item.MonthName }}
        </div>
      </div>
      <el-tabs
        type="border-card"
        v-model="currentIndex"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in RecommendItem"
          :key="index"
          :label="`${weekList[weekIndex == -1 ? 0 : weekIndex].MonthName}菜谱${
            index + 1
          }`"
          :name="index + ''"
        >
          <div v-html="item.ContentHtml" class="tui-Content"></div>
        </el-tab-pane>
      </el-tabs>

      <el-dialog
        title="选择时间"
        :visible.sync="dialogVisibleTime"
        width="30%"
        append-to-body
      >
        <div class="flex-center" style="width: 100%">
          <el-date-picker
            v-model="starttime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="onClickCancle">取 消</el-button>
          <el-button type="primary" @click="submitFood">确 定</el-button>
        </span>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRecommend = false">取 消</el-button>
        <el-button type="primary" @click="onClickFoodTrue"
          >选择该食谱</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetWeekHorizontalReciperInfo,
  GetTempFoodHorizontalRecipesInfo,
  CheckWeekReciperInfo,
  GetFoodDish,
  GetFoodLibrary,
  AddWeekReciperInfo,
  UpdateWeekReciperInfo,
  DeleteWeekReciperInfo,
  GetFoodMonth,
  DeleteDayRecipesInfo,
  LookWeekDayRecipesInfo,
  GetTableTempFoodHorizontalRecipesInfo,
} from "../../../api/api";
import moment from "moment";

export default {
  data() {
    return {
      isActive: false,
      dateOptions: [
        {
          label: "周一",
        },
        {
          label: "周二",
        },
        {
          label: "周三",
        },
        {
          label: "周四",
        },
        {
          label: "周五",
        },
      ],
      foodLunch: [
        {
          name: "早点",
        },
        {
          name: "午餐",
        },
        {
          name: "午点",
        },
      ],
      foodCharacter: [
        {
          name: "正常",
        },
        {
          name: "体弱儿",
        },
        {
          name: "病号菜",
        },
      ],
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      Title: "",
      indexInfo: {
        date: "",
      },
      ruleForm: {
        foodDishId: "",
        foodDishName: "",
        type: "",
        apply: "",
        gradeIdentity: "",
        weekDay: "",
        FoodJson: "",
        secType: "",
        foodDish: "",
        foodLibaryId: "",
        foodLibaryName: "",
        weight: 0,
      },
      userInfo: {},
      foodJsonId: 0,
      foodJson: [],
      agsList: [
        {
          Name: "托班;小班",
        },
        {
          Name: "中班",
        },
        {
          Name: "大班",
        }
      ],
      rowIndex: "-1",
      OrderIndexArr: [],
      hoverOrderArr: [],
      spanArr: [], //二维数组，用于存放单元格合并规则
      position: 0, //用于存储相同项的开始index
      dialogVisibleRecommend: false,
      RecommendItem: [],
      lunch: [],
      currentIndex: "0",
      starttime: [],
      dialogVisibleTime: false,
      isCover: 0,
      secTypeList: [
        {
          name: "主食",
        },
        {
          name: "菜肴",
        },
        {
          name: "汤",
        },
        {
          name: "水果",
        },
      ],
      SysFoodRecipesId: 0,
      foodDishList: [
        {
          label: "食材/食物",
        },
        {
          label: "菜肴",
        },
      ],
      rules: {
        weekDay: [{ required: true, message: "请选择时间", trigger: "change" }],
        gradeIdentity: [
          { required: true, message: "请选择年龄段", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择用餐时段", trigger: "change" },
        ],
        secType: [{ required: true, message: "请选择主食", trigger: "change" }],
        foodDish: [
          { required: true, message: "请选择菜肴", trigger: "change" },
        ],
        foodLibaryName: [
          { required: true, message: "请选择食物/食材", trigger: "blur" },
        ],
        foodDishName: [
          { required: true, message: "请选择菜肴", trigger: "blur" },
        ],
        weight: [{ required: true, message: "请输入克数", trigger: "blur" }],
        apply: [
          { required: true, message: "请选择菜肴特性", trigger: "change" },
        ],
      },
      foodTitle: "",
      foodArr: [],
      IsData: false,
      weekList: [],
      weekIndex: 0,
      timeDasibale: false,
      TableStr: "",
      isOpen: false,
      isShowBtn: false,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    await this.getNowTime();

    const format = "YYYY-MM-DD";
    const startTime = moment(this.indexInfo.date, format);
    const endTime = moment(this.getCurrWeekDays()[1], format);

    const diff1 = moment(endTime).diff(moment(startTime), "years");
    const diff2 = moment(endTime).diff(moment(startTime), "months");
    const diff3 = moment(endTime).diff(moment(startTime), "days");

    console.log(diff1, diff2, diff3);
    console.log(diff3 < 0);
    if (diff3 < 0) {
      this.timeDasibale = true;
    } else {
      this.timeDasibale = false;
    }

    await this.LookWeekDayRecipesInfo();
  },
  methods: {
    onChangeFoodDish(e) {
      console.log(e);
      if (e == "食材/食物") {
        this.ruleForm.foodLibaryId = 0;
      } else {
        this.ruleForm.foodDishId = 0;
      }
    },
    handleSelect(item) {
      console.log(item);
      if (this.ruleForm.foodDish == "菜肴") {
        this.ruleForm.foodDishId = item.Id;
        this.ruleForm.foodDishName = item.value;
      } else {
        this.ruleForm.foodLibaryId = item.Id;
        this.ruleForm.foodLibaryName = item.value;
      }
    },
    // 导出
    async onClickExport() {
      window.open(
        "http://importv3.mushroomisland.cn/api/Food/ExportWeekDayRecipesInfo?SchoolId=" +
          this.userInfo.SchoolId +
          "&ShowDate=" +
          this.indexInfo.date,
        "_blank"
      );
    },
    async GetTableTempFoodHorizontalRecipesInfo() {
      let res = await GetTableTempFoodHorizontalRecipesInfo({
        id: this.weekList[this.weekIndex == -1 ? 0 : this.weekIndex].Month,
      });
      if (res.data.success) {
        this.RecommendItem = res.data.response;
      }
    },
    onClickOpen() {
      this.isOpen = true;
      this.isShowBtn = true;
      this.GetWeekHorizontalReciperInfo();
    },
    onClickOpenBtn() {
      this.isOpen = false;
      this.isShowBtn = false;
      this.LookWeekDayRecipesInfo();
    },
    // 观看菜谱
    async LookWeekDayRecipesInfo() {
      let res = await LookWeekDayRecipesInfo({
        ShowDate: this.indexInfo.date,
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.TableStr = res.data.response;
      } else {
        this.TableStr = "";
      }
    },
    // 获取周一到周五的时间段
    chatGptData(time) {
      let now = new Date();
      let dayOfWeek = now.getDay();
      let startOfWeek = new Date(
        now.getTime() - (dayOfWeek - 1) * 24 * 60 * 60 * 1000
      );
      let endOfWeek = new Date(
        now.getTime() + (7 - dayOfWeek) * 24 * 60 * 60 * 1000
      );
      let formattedDate = moment(startOfWeek).format("YYYY-MM-DD");
      let EndformattedDate = moment(endOfWeek).format("YYYY-MM-DD");
      console.log("Start of week: ", formattedDate);
      console.log("End of week: ", EndformattedDate);
    },
    diffStartTime(start, end, dDueDate) {
      console.log(start, end, dDueDate);
      const format = "YYYY/MM/DD"; //日期格式

      const diffStart =
        moment(start, format).diff(moment(dDueDate, format), "days") <= 0;
      const diffEnd =
        moment(end, format).diff(moment(dDueDate, format), "days") >= 0;
      const diffDtate = diffStart && diffEnd;

      console.log(diffDtate); // true
      return diffDtate;
    },
    // 获取当前周的开始结束时间
    getCurrWeekDays() {
      let date = [];
      let weekOfday = parseInt(moment().format("d")); // 计算今天是这周第几天 周日为一周中的第一天
      let start = moment().subtract(weekOfday, "days").format("YYYY-MM-DD"); // 周一日期
      let end = moment()
        .add(7 - weekOfday - 1, "days")
        .format("YYYY-MM-DD"); // 周日日期
      date.push(start);
      date.push(end);
      return date;
    },
    onClickCancle() {
      this.dialogVisibleTime = false;
      this.starttime = [];
    },
    onClickWeek(index, item) {
      // item.IsNow = true;
      this.weekIndex = index;
      this.currentIndex = "0";
      this.GetTableTempFoodHorizontalRecipesInfo();
    },
    // 获取月谱
    async GetFoodMonth() {
      let res = await GetFoodMonth();
      if (res.data.success) {
        this.weekList = res.data.response;
        let index = res.data.response.findIndex((item) => item.IsNow);
        this.weekIndex = index == -1 ? 0 : index;
        console.log(index);
      } else {
        this.weekList = [];
      }
    },
    async onClickDeleteDrop(e, item) {
      console.log(item);
      this.$confirm("此操作将删除所选周, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteDayRecipesInfo({
          SysFoodRecipesId: this.SysFoodRecipesId,
          WeekDay: item.WeekDay,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "成功！",
          });
          this.GetWeekHorizontalReciperInfo();
        } else {
          this.$message({
            type: "error",
            message: "失败！",
          });
        }
      });
    },
    onClickDropdown(e, val, item, type, SecType) {
      console.log(e, val);
      if (e == "edit") {
        this.foodTitle = "编辑本周菜肴";
        this.ruleForm = {
          foodDishId: val.FoodDishId,
          foodDishName: val.FoodDishId == 0 ? "" : val.DishName,
          type: type,
          apply: val.Apply,
          gradeIdentity: item.GradeName,
          weekDay: item.WeekDay,
          secType: SecType,
          foodDish: val.FoodDishId != 0 ? "菜肴" : "食材/食物",
          foodLibaryId: val.FoodLibaryId == 0 ? "" : val.FoodLibaryId,
          foodLibaryName: val.FoodLibaryId == 0 ? "" : val.DishName,
          weight: val.weight,
          Id: val.Id,
        };
        this.dialogVisible = true;
      } else {
        this.ruleForm.Id = val.Id;
        this.onClickDeleteFood();
      }
    },
    // 删除本周菜肴
    async onClickDeleteFood() {
      this.$confirm("此操作将删除所选菜肴, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteWeekReciperInfo({
          SysFoodRecipesId: this.SysFoodRecipesId,
          Id: this.ruleForm.Id,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "成功！",
          });
          this.GetWeekHorizontalReciperInfo();
        } else {
          this.$message({
            type: "error",
            message: "失败！",
          });
        }
      });
    },
    // 选择该食谱
    async submitFood() {
      let res = await CheckWeekReciperInfo({
        SysFoodRecipesId:
          this.RecommendItem[Number(this.currentIndex)].SysFoodRecipesId,
        foodRecipesName: `${this.weekList[this.weekIndex].MonthName}菜谱${
          this.currentIndex + 1
        }`,
        showDate: this.starttime[0],
        isCover: this.isCover,
      });
      if (res.data.response == "是否覆盖") {
        this.$confirm("是否覆盖已有食谱?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isCover = 1;
          this.submitFood();
        });
      }
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "成功！",
        });
        this.starttime = [];
        this.dialogVisibleTime = false;
        this.dialogVisibleRecommend = false;
        // if (!this.isShowBtn) {
        //   this.LookWeekDayRecipesInfo();
        // } else {
        //   this.GetWeekHorizontalReciperInfo();
        // }
        this.GetWeekHorizontalReciperInfo();
      }
    },
    // 选择该食谱
    onClickFoodTrue() {
      this.getDate();
      this.dialogVisibleTime = true;
    },
    formatDate(str) {
      // 根据 - 符号拆分
      return str
        .split("-")
        .map((item) => {
          // +item 将item字符串转换为数字
          // 小于10的时候就补全一个前缀0
          if (+item < 10) {
            return "0" + +item;
          }

          // 大于10的时候不用补0
          return item;
        })
        .join("-"); // 最后重组回来
    },
    getDate() {
      // console.log(this.indexInfo.date, "this.indexInfo.date");

      let now = new Date(this.indexInfo.date);
      let day = now.getDay();

      // 获取本周一的时间戳
      let Monday = moment(
        new Date(now - (day - 1) * 86400000).getTime()
      ).format("YYYY-MM-DD");
      // 其他天类推
      // let Tuesday = moment(
      //   new Date(now - (day - 2) * 86400000).getTime()
      // ).format("YYYY-MM-DD");
      // let Wednesday = moment(
      //   new Date(now - (day - 3) * 86400000).getTime()
      // ).format("YYYY-MM-DD");
      // let Thursday = moment(
      //   new Date(now - (day - 4) * 86400000).getTime()
      // ).format("YYYY-MM-DD");
      // let Friday = moment(
      //   new Date(now - (day - 5) * 86400000).getTime()
      // ).format("YYYY-MM-DD");
      // let Saturday = moment(
      //   new Date(now - (day - 6) * 86400000).getTime()
      // ).format("YYYY-MM-DD");
      let Sunday = moment(
        new Date(now - (day - 7) * 86400000).getTime()
      ).format("YYYY-MM-DD");

      this.starttime = [Monday, Sunday];
      console.log(this.starttime);
    },
    getWeekDataList(data) {
      console.log(data, "data");
      let oneDayTime = 1000 * 60 * 60 * 24;
      let today = new Date(data);
      let todayDay = today.getDay() || 7;
      let startDate = new Date(today.getTime() - oneDayTime * (todayDay - 1));
      let dateList = [];
      for (let i = 0; i < 7; i++) {
        let temp = new Date(startDate.getTime() + i * oneDayTime);
        let year = temp.getFullYear();
        let month =
          temp.getMonth() + 1 < 10
            ? "0" + (temp.getMonth() + 1)
            : temp.getMonth() + 1;
        let day = temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate();
        dateList[i] = `${year}-${month}-${day}`;
      }
      return dateList;
    },
    async getNowTimes() {
      // 第一步: 获取今天是本周的第几天
      const weekOfday = moment().format("E");

      // 第二步: 获取本周周一的日期
      const lastMonday = moment()
        .subtract(weekOfday - 1, "days")
        .format("yyyy-MM-DD");
      // 第三步: 获取本周周末的日期
      const lastSunday = moment()
        .add(5 - weekOfday, "days")
        .format("yyyy-MM-DD");
      console.log(lastMonday, lastSunday, "日期");
      // this.starttime.push(lastMonday);
      this.starttime.push(this.getWeekDataList(this.indexInfo.date)[0]);
      this.starttime.push(this.getWeekDataList(this.indexInfo.date)[6]);
    },
    handleClick(e) {
      this.currentIndex = e.index;
      this.GetTableTempFoodHorizontalRecipesInfo();
    },
    async onRecommend() {
      await this.GetFoodMonth();
      // await this.GetTempFoodHorizontalRecipesInfo();
      await this.GetTableTempFoodHorizontalRecipesInfo();
      this.dialogVisibleRecommend = true;
    },

    onChangeTime(e) {
      this.indexInfo.date = e;

      if (new Date(this.getNextMonday()) > new Date(e)) {
        this.timeDasibale = false;
      } else {
        this.timeDasibale = true;
      }

      if (!this.isShowBtn) {
        this.LookWeekDayRecipesInfo();
      } else {
        this.GetWeekHorizontalReciperInfo();
      }
      // this.GetWeekHorizontalReciperInfo();
    },
    getNextMonday() {
      var date = new Date();
      var day = date.getDay();
      var monday;
      monday = date.getTime() + 1000 * 60 * 60 * 24 * (1 + 7 - day);
      return new Date(monday).toLocaleDateString().replace(/\//g, "-");
    },
    getFoodJson(val) {
      if (val) {
        return JSON.parse(val);
      }
    },
    //表格单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 2; i++) {
        if (columnIndex == i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;

          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    objectSpanMethods({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 2; i++) {
        if (columnIndex == i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;

          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    // 合并单元格
    tableRowClassName({ row, rowIndex }) {
      let arr = this.hoverOrderArr;
      for (let i = 0; i < arr.length; i++) {
        if (rowIndex == arr[i]) {
          return "hovered-row";
        }
      }
    },

    cellMouseLeave(row, column, cell, event) {
      this.rowIndex = "-1";
      this.hoverOrderArr = [];
    },
    cellMouseEnter(row, column, cell, event) {
      this.rowIndex = row.rowIndex;
      this.hoverOrderArr = [];
      this.OrderIndexArr.forEach((element) => {
        if (element.indexOf(this.rowIndex) >= 0) {
          this.hoverOrderArr = element;
        }
      });
    },

    // 提交
    async addSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.foodTitle == "新增本周菜肴") {
            if (this.IsData) {
              let params = {
                SysFoodRecipesId: this.SysFoodRecipesId,
                weekDay: this.ruleForm.weekDay,
                gradeIdentity: this.ruleForm.gradeIdentity,
                type: this.ruleForm.type,
                secType:
                  this.ruleForm.apply == "正常"
                    ? this.ruleForm.secType == ""
                      ? this.ruleForm.type
                      : this.ruleForm.secType
                    : "",
                dishName:
                  this.ruleForm.foodDish == "菜肴"
                    ? this.ruleForm.foodDishName
                    : this.ruleForm.foodLibaryName,
                foodLibaryId:
                  this.ruleForm.foodLibaryId == ""
                    ? 0
                    : this.ruleForm.foodLibaryId,
                foodDishId:
                  this.ruleForm.foodDishId == "" ? 0 : this.ruleForm.foodDishId,
                weight: this.ruleForm.weight,
                apply: this.ruleForm.apply,
              };
              console.log(params, "params");
              let res = await AddWeekReciperInfo(params);
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: "成功！",
                });
                this.resetData();
                this.$refs[formName].resetFields(); // 重置表单移除校验
                this.GetWeekHorizontalReciperInfo();
                this.LookWeekDayRecipesInfo();
                this.dialogVisible = false;
              } else {
                this.$message({
                  type: "error",
                  message: "失败！",
                });
              }
            } else {
              this.$message({
                type: "error",
                message: "请选择菜肴，无法查询到的无法添加",
              });
            }
          } else {
            if (this.ruleForm.foodDish == "菜肴") {
              let xhr = await GetFoodDish();
              if (xhr.data.success) {
                xhr.data.response.find((cc) => {
                  if (cc.Name === this.ruleForm.foodDishName) {
                    this.getEditFood(formName);
                  }
                });
              }
            } else {
              let xhr = await GetFoodLibrary();
              if (xhr.data.success) {
                xhr.data.response.find((cc) => {
                  if (cc.Name === this.ruleForm.foodLibaryName) {
                    this.getEditFood(formName);
                  }
                });
              }
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async getEditFood(formName) {
      let params = {
        SysFoodRecipesId: this.SysFoodRecipesId,
        weekDay: this.ruleForm.weekDay,
        gradeIdentity: this.ruleForm.gradeIdentity,
        type: this.ruleForm.type,
        secType:
          this.ruleForm.apply == "正常"
            ? this.ruleForm.secType == ""
              ? this.ruleForm.type
              : this.ruleForm.secType
            : "",
        dishName:
          this.ruleForm.foodDish == "菜肴"
            ? this.ruleForm.foodDishName
            : this.ruleForm.foodLibaryName,
        foodLibaryId:
          this.ruleForm.foodDish != "菜肴" ? this.ruleForm.foodLibaryId : 0,
        foodDishId:
          this.ruleForm.foodDish == "菜肴" ? this.ruleForm.foodDishId : 0,
        weight: this.ruleForm.weight,
        apply: this.ruleForm.apply,
        Id: this.ruleForm.Id,
      };
      let res = await UpdateWeekReciperInfo(params);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "成功！",
        });
        this.resetData();
        this.$refs[formName].resetFields(); // 重置表单移除校验
        this.GetWeekHorizontalReciperInfo();
        // this.LookWeekDayRecipesInfo();
        this.dialogVisible = false;
      } else {
        this.$message({
          type: "error",
          message: "失败！",
        });
      }
    },
    resetData() {
      this.ruleForm = {
        foodDishId: "",
        foodDishName: "",
        type: "",
        apply: "",
        gradeIdentity: "",
        weekDay: "",
        FoodJson: "",
        secType: "",
        foodDish: "",
        foodLibaryId: "",
        foodLibaryName: "",
        weight: 0,
      };
    },
    onClickDelete(index) {
      this.foodJson.splice(index, 1);
    },

    async querySearchAsync(queryString, cb) {
      if (queryString != "") {
        if (this.ruleForm.foodDish == "菜肴") {
          let callBackArr = [];
          let res = await GetFoodDish();
          if (res.data.success) {
            res.data.response.forEach((item) => {
              if (item.Name.indexOf(queryString) > -1) {
                callBackArr.push({
                  Id: item.Id,
                  value: item.Name,
                });
              }
            });
            //console.log(callBackArr);
            if (callBackArr.length == 0) {
              callBackArr.push({
                value: "暂无数据",
              });
              cb(callBackArr);
              this.IsData = false;
            } else {
              this.IsData = true;

              cb(callBackArr);
            }
          }
        } else {
          // 食材/食物
          let callBackArr = [];
          let res = await GetFoodLibrary();
          if (res.data.success) {
            res.data.response.forEach((item) => {
              if (item.Name.indexOf(queryString) > -1) {
                callBackArr.push({
                  Id: item.Id,
                  value: item.Name,
                });
              }
            });
            //console.log(callBackArr);
            if (callBackArr.length == 0) {
              callBackArr.push({
                value: "暂无数据",
              });
              this.IsData = false;
              cb(callBackArr);
            } else {
              this.IsData = true;
              cb(callBackArr);
            }
          }
        }
      }
    },
    async GetWeekHorizontalReciperInfo() {
      const params = {
        ShowDate: this.indexInfo.date,
      };
      let res = await GetWeekHorizontalReciperInfo(params);
      if (res.data.success) {
        this.tableData = res.data.response.List;
        this.rowspan(0, "WeekDay");
        this.rowspan(1, "GradeName");
        this.SysFoodRecipesId = res.data.response.SysFoodRecipesId;
        console.log(this.SysFoodRecipesId, "this.SysFoodRecipesId");
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    rowspans(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.lunch.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.lunch[index][prop] === this.lunch[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    //  编辑本周食谱
    async onEditFood() {
      this.foodTitle = "新增本周菜肴";
      this.dialogVisible = true;
      const params = {
        ShowDate: this.indexInfo.date,
      };
      let res = await GetWeekHorizontalReciperInfo(params);
      if (res.data.success) {
        this.SysFoodRecipesId = res.data.response.SysFoodRecipesId;
        console.log(this.SysFoodRecipesId, "this.SysFoodRecipesId");
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.indexInfo, "date", defaultDate);
    },
    onClickAdd() {
      this.Title = "新增今日上报食材";
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.tui-Content table {
  width: 100%;
  border: 1px solid #ebeef5;
  margin: 0 auto;
  border-collapse: collapse;
  background: #fff;
}

.tui-bod {
  font-weight: 600;
  font-size: 0.1875rem;
}

/deep/.tui-Content td {
  padding: 0.125rem;
  border: 1px solid #ebeef5;
  text-align: center;
  vertical-align: center;
  transition: background-color 0.25s ease;
  font-size: 0.175rem;
  min-width: 1.25rem;
}

/deep/.tui-Content tr {
  background: #fff;
}

/deep/.tui-Content tr:nth-child(1) {
  font-weight: 600;
  font-size: 0.1875rem;
}

/deep/.tui-Content tr:nth-child(2) {
  font-weight: 600;
  font-size: 0.1875rem;
}

/deep/.tui-Content tr:nth-child(3) {
  font-weight: 600;
  font-size: 0.1875rem;
}

.List {
  height: 30px;
  margin-bottom: 10px;

  .grade {
    position: relative;
    display: inline-block;
    min-width: 83px;
    height: 30px;
    border: 1px solid #cdcdcd;
    background: #e5ebff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding-right: 14px;
    padding-left: 34px;
    box-sizing: border-box;
    line-height: 30px;
    color: #333333;
    cursor: pointer;
  }

  .grade:nth-child(1) {
    padding-left: 14px;
  }

  .gradeActive {
    color: #ffffff;
    background: #5474e6;
    border: 1px solid #5474e6;
  }
}

.el-row {
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

// .bg-purple-dark:nth-child(2n) {
//   background: olive;
// }
.bg-color {
  background: rgb(51, 153, 255);
  color: #fff;
}

.bg-purple-dark {
  background: rgb(204, 236, 255);
  color: #333;
  font-weight: 600;

  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    width: 100px;
  }
}

.bg-purple {
  background: #d3dce6;
  color: #fff;
}

.bg-purple-light {
  background: #e5e9f2;
  color: #fff;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.mg-right {
  margin-right: 20px;
}

.mg-bottom {
  margin-bottom: 10px;
}

.tui-food {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
}

.flex-arounds {
  display: flex;
  justify-content: space-around;
}
</style>